import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import { ApplicantRequestState } from '../reducers/applicant-request.reducers';
import { EasePortalConstants } from '@shared/constants/ease-portal-constants';
import { CorrespondenceElementEnum } from '@shared/enums/correspondenceElement.enum';
import { ApplicantRequestDto } from '@shared/models/applicant-request-dto';

const applicantRequestFeatureSelector = createFeatureSelector<ApplicantRequestState>('applicantRequests');

export const selectCountApplicantRequests = createSelector(
    applicantRequestFeatureSelector,
    ({ requests }) => requests?.length
);

export const selectPagedApplicantRequests = createSelector(
    applicantRequestFeatureSelector,
    ({ requests, sort, page }): ApplicantRequestDto[] => [...requests].sort((r1, r2) => {
        if(!sort) {
            return 0;
        }

        const a = r1[sort.by];
        const b = r2[sort.by];

        if (sort.ascending) {
            return (a < b) ? -1 : (a > b ? 1 : 0)
        } else {
            return (a > b) ? -1 : (a < b ? 1 : 0)
        }

    }).slice(((page - 1) * EasePortalConstants.TABLE_PAGE_SIZE), page * EasePortalConstants.TABLE_PAGE_SIZE)
);

export const selectCaseDetails = createSelector(
    applicantRequestFeatureSelector,
    ({ caseDetails }) => caseDetails
);

export const selectCaseDetailActionRequiredList = createSelector(
    selectCaseDetails,
    ({ communication }) =>
        communication
            .filter(c => c.actionRequired)
);

export const selectCaseDetailCommunications = createSelector(
    selectCaseDetails,
    ({ communication }) =>
        communication
            .filter(c =>
                ![CorrespondenceElementEnum.REPLY_TO_INITIAL_REQUEST,
                    CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST,
                    CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL
                ].includes(CorrespondenceElementEnum.dbElementKey(c.correspondenceElement) as CorrespondenceElementEnum)
            )
            .reverse()
);

export const selectCaseDetailReplyToInitialRequestList = createSelector(
    selectCaseDetails,
    ({ communication }) =>
        communication
            .filter(c =>
                CorrespondenceElementEnum.dbElementKey(c.correspondenceElement) === CorrespondenceElementEnum.REPLY_TO_INITIAL_REQUEST)
);

export const selectCaseDetailReplyToConfirmatoryRequestList = createSelector(
    selectCaseDetails,
    ({ communication }) =>
        communication
            .filter(c =>
                [
                    CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST,
                    CorrespondenceElementEnum.REPLY_TO_CONFIRMATORY_REQUEST_PARTIAL
                ].includes(CorrespondenceElementEnum.dbElementKey(c.correspondenceElement) as CorrespondenceElementEnum)
            )
);

export const selectInitialCaseDetails = createSelector(
    applicantRequestFeatureSelector,
    ({ initialCaseDetails }) => initialCaseDetails
);

export const selectCorrespondenceDetails = (correspondenceId: number) => createSelector(
    applicantRequestFeatureSelector,
    ({ correspondenceOpened }) => correspondenceOpened[correspondenceId]
);

export const selectSelectedTabId = createSelector(
    applicantRequestFeatureSelector,
    ({ selectedTabId }) => selectedTabId
);

export const selectDraftConfirmatoryRequest = createSelector(
    applicantRequestFeatureSelector,
    ({ draftConfirmatoryRequest }) => draftConfirmatoryRequest
);
